import { render, staticRenderFns } from "./AskAutomaticInvestment.vue?vue&type=template&id=6a730802&"
import script from "./AskAutomaticInvestment.vue?vue&type=script&lang=js&"
export * from "./AskAutomaticInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports